import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import SignInForm from '../../../components/V2/Homepage/Onboarding/SignInForm';
import { useDomainConfig } from '../../../hooks/useDomainConfig';

const SignInAuth = () => {
	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	return (
		<>
			<Box p="16px" maxW="500px" mx="auto">
				<SignInForm />
			</Box>
			{
				// @ts-ignore
				domainConfig && domainConfig?.isOldData && (
					<Text maxW={{base:"328px", md:"none"}} pt={"30px"} m={"auto"} textAlign={"center"} color={'#F00'} fontFamily={'Open Sans'} fontSize={'12px'} fontStyle={'normal'} fontWeight={'600'} lineHeight={'normal'}>
						NOTE: Please log in with your email ID or phone number that you used to sign up originally.
					</Text>
				)
			}
		</>
	);
};

export default SignInAuth;
